export default "__VITE_ASSET__DkjRjPje__"